import React from "react";
import { CHART_TAB, TOOL_TEMPLATE } from "../../constant/common";
import { useTemplateSetting } from "../../hooks/useCompanySettings";
import i18n from "../../locale/i18n";
import { classNames } from "../../utils";
import IconByTemplate from "../IconByTemplate";
import Label from "../ui/Label";
import { Tooltip } from "@euroland/react-tooltip";
import ColorBlindModeButton from "../ColorBindModeButton";
import { Tab, TabList } from "@euroland/react-tablist";

const HighChartControl = ({ chart, setChart }) => {
  const template = useTemplateSetting();
  const label = chart === CHART_TAB.SPLINE_CHART ? "cumulativeChange" : "periodicalChange";

  const isLineChart = chart === CHART_TAB.SPLINE_CHART;
  const isColumnChart = chart === CHART_TAB.COLUMN_CHART;

  return (
    <div className="highchart--wrapper">
      <div className="highchart-control">
        <TabList className="chart-tab-list" ariaLabel={i18n.translate("chartTabs")}>
          <Tooltip label={i18n.translate("cumulativeChange")}>
            <Tab value={CHART_TAB.SPLINE_CHART} ariaLabel={i18n.translate("cumulativeChange")}>
              <div className={classNames("highchart-control__icon", { active: isLineChart })}>
                <IconByTemplate quadrata="axis-line-chart" victor="line-chart"></IconByTemplate>
              </div>
            </Tab>
          </Tooltip>
          <Tooltip label={i18n.translate("periodicalChange")}>
            <Tab value={CHART_TAB.COLUMN_CHART} ariaLabel={i18n.translate("periodicalChange")}>
              <div
                className={classNames("highchart-control__icon tooltip-wrapper", { active: isColumnChart })}
              >
                <IconByTemplate quadrata="thin-column-chart" victor="stack-chart"></IconByTemplate>
              </div>
            </Tab>
          </Tooltip>
        </TabList>
        {template === TOOL_TEMPLATE.quadrata && (
          <Label className="highchart-control__label">{i18n.translate(label)}</Label>
        )}
      </div>
      <ColorBlindModeButton />
    </div>
  );
};

export default HighChartControl;
